// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var BrokerMessageResponseType;
(function (BrokerMessageResponseType) {
    BrokerMessageResponseType[BrokerMessageResponseType["RADIO_BTNS"] = 1] = "RADIO_BTNS";
    BrokerMessageResponseType[BrokerMessageResponseType["CUSTOM_BTNS"] = 2] = "CUSTOM_BTNS";
    BrokerMessageResponseType[BrokerMessageResponseType["WAS_READ"] = 3] = "WAS_READ";
})(BrokerMessageResponseType || (BrokerMessageResponseType = {}));
